// extracted by mini-css-extract-plugin
export default {"BuildingDevelopersBlock":"BuildingDevelopersBlock_BuildingDevelopersBlock__2m3rm","list":"BuildingDevelopersBlock_list__G4n8y","post":"BuildingDevelopersBlock_post__mXG4h"};